import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SINGLE } from "../../../../constants/numbers.consts.js";
import Typography from "../../../../components/atoms/Typography/index.js";
import RenderList from "../../../../components/atoms/RenderList/index.js";
import ProductLogo from "../../../../components/atoms/ProductLogo/index.js";
import { Main, CardButton, CardContent } from "../AppSwitcher.components.js";
const appSwitcherMapper = {
    care4: "SDB Care4",
    "digital-care": "SDB Digitale Zorg",
    "ecd-vvt": "SDB ECD",
    hr: "SDB HR",
    learning: "SDB Leerplatform",
    planning: "SDB Planning",
    salary: "SDB Salaris",
    analytics: "SDB Analytics",
    "analytics-budget": "SDB Analytics Budget",
    "data-station": "SDB DataStation",
    analyticsBudget: "SDB Analytics Budget",
    one: "SDB One",
    "hr-salary-admin": "SDB HR/Salaris Beheer",
    identity: "SDB Identity",
    kis: "SDB KIS",
    octopus: "SDB Octopus",
    user: "SDB User",
    jo: "Jouw Omgeving",
    karify: "Karify",
};
export const AppSwitcherMenuMainComponent = ({ data = [], isLoading = false, ...props }) => (_jsx(Main, { "data-testid": "AppSwitcherMenuMain", ...props, children: _jsx(RenderList, { data: data
            .map((item) => ({
            ...item,
            name: appSwitcherMapper[item.appType] || "",
        }))
            .sort((a, b) => {
            if (a.addLast && !b.addLast)
                return SINGLE;
            return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        }), children: ({ appType, name, url, isCurrentApp }) => (_jsx(CardButton, { href: isCurrentApp ? "" : url, isLoading: isLoading, "data-testid": "AppSwitcherMenuMainItem", slotProps: {
                item: {
                    sx: {
                        ...(isCurrentApp && {
                            backgroundColor: ({ vars }) => vars.palette.surface.containerHighest,
                            pointerEvents: "none",
                        }),
                    },
                },
            }, children: _jsxs(CardContent, { children: [_jsx(ProductLogo, { type: appType }), _jsx(Typography, { variant: "title", children: name })] }) })) }) }));
export default AppSwitcherMenuMainComponent;
